import React, { FC } from "react";
import RHFormTextField, { RHFormTextFieldProps } from "./RHFormTextField";
import { useFormContext } from "react-hook-form";

export type RHFormConsumerTextFieldProps = Omit<
  RHFormTextFieldProps,
  "control"
>;

export const RHFormConsumerTextField: FC<RHFormConsumerTextFieldProps> = ({
  prefix,
  name,
  autoComplete,
  children,
  defaultValue,
  fullWidth = false,
  inputProps,
  label,
  rules,
  select = false,
  disabled,
  ...rest
}) => {
  const { control, errors } = useFormContext();
  const prefixName = `${prefix ? `${prefix}.` : ""}${name}`;
  return (
    <RHFormTextField
      control={control}
      data-testid={prefixName}
      id={prefixName}
      name={prefixName}
      error={prefix ? errors?.[prefix]?.[name] : errors?.[name]}
      autoComplete={autoComplete}
      children={children}
      defaultValue={defaultValue}
      fullWidth={fullWidth}
      inputProps={inputProps}
      label={label}
      rules={rules}
      select={select}
      disabled={disabled}
      {...rest}
    />
  );
};
